import { useState } from "react"
import { Alert, Button, IconButton, Stack } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { DataQualityTasksDrawer } from "./data-quality-tasks-drawer"

export function DataQualityAlertRow({ item, onDismiss, regimeId, currencySymbol, scenarioId, variantId, regimeName }) {
    const [tasksOpen, setTasksOpen] = useState(false)
    return (
        <Alert
            severity={item.severity}
            action={
                <Stack direction="row" spacing={0.5} alignItems="center">
                    {item.action || null}
                    <IconButton
                        data-cy={`data-quality-alert-dismiss-${item.id}`}
                        size="small"
                        onClick={handleDismiss}
                        aria-label="Dismiss this note"
                    >
                        <Iconify icon="eva:close-fill" />
                    </IconButton>
                </Stack>
            }
            sx={{ "& .MuiAlert-action": { alignItems: "center", pt: 0, mr: 0 }, "& .MuiAlert-message": { flex: 1 } }}
        >
            {item.message}
            <If value={!!item.detail}>
                <div>
                    <Button
                        size="small"
                        color="inherit"
                        data-cy={`data-quality-alert-view-tasks-${item.id}`}
                        onClick={handleShowTasks}
                        sx={{ mt: 0.5, textTransform: "none", fontWeight: 600 }}
                        endIcon={<Iconify icon="mdi:chevron-right" />}
                    >
                        {getViewTasksLabel()}
                    </Button>
                    <DataQualityTasksDrawer
                        open={tasksOpen}
                        onClose={handleCloseTasks}
                        alertId={item.id}
                        detail={item.detail}
                        regimeId={regimeId}
                        currencySymbol={currencySymbol}
                        scenarioId={scenarioId}
                        variantId={variantId}
                        regimeName={regimeName}
                    />
                </div>
            </If>
        </Alert>
    )

    function handleDismiss() {
        onDismiss?.(item.id)
    }

    function handleShowTasks() {
        setTasksOpen(true)
    }

    function handleCloseTasks() {
        setTasksOpen(false)
    }

    function getViewTasksLabel() {
        const total = item.detail?.total || 0
        return `View ${total} affected ${total === 1 ? "task" : "tasks"}`
    }
}
